import useTwilioCall from "./twilio/useTwilioCall";
import useAlertUploader from "./useAlertUploader";
import useCameraGrab from "./useCameraGrab";
import useCameraGrabUploader from "./useCameraGrabUploader";
import useDetectPasteText from "./useDetectPasteText";
import useDetectTabSwitch from "./useDetectTabSwitch";
import useFaceObjectDetection from "./useFaceObjectDetection";
import useScreenGrabUploader from "./useScreenGrabUploader";
import useVideoRecordingUploader from "./useVideoRecordingUploader";
import usePriorityAlertUploader from "./usePriorityAlertUploader";
import useWatchNetworkStatus from "./useWatchNetworkStatus";
import useScreenShareFullScreenCheck from "./useScreenShareFullScreenCheck";
import useScreenGrab from "./useScreenGrab";
import useSecondaryDevice from "./useSecondaryDevice";
import useDetectPrintScreen from "./useDetectPrintScreen";
import useVideoRecording from "./useVideoRecording";
import useTabCloseOrRefresh from "./useBeforeUnload";
import useDetectMultiMonitor from "./useDetectMultiMonitor";
import useNoiseDetection from "./useNoiseDetection";
import useRecorder from "./useRecorder";
import useWatchPauseStatus from "./useWatchPauseStatus";
import useWatchSecondaryDisabled from "./useWatchSecondaryDisabled";
import usePreflightCheck from "./usePreflightCheck";
import useWatchAlerts from "./useWatchAlerts";
import useWatchMonitoringAlerts from "./useWatchMonitoringAlerts";

const useRegister = (shouldRegister = true) => {
  useAlertUploader();
  useCameraGrab();
  useFaceObjectDetection();
  useDetectPasteText();
  useDetectTabSwitch();
  useRecorder();
  useVideoRecording();
  useScreenGrabUploader();
  useCameraGrabUploader();
  useVideoRecordingUploader();
  useTwilioCall();
  useWatchNetworkStatus();
  useWatchPauseStatus();
  useWatchSecondaryDisabled();
  useScreenShareFullScreenCheck();
  useScreenGrab();
  useSecondaryDevice();
  usePriorityAlertUploader();
  useDetectPrintScreen();
  useTabCloseOrRefresh(shouldRegister);
  useNoiseDetection();
  useDetectMultiMonitor();
  usePreflightCheck();
  useWatchAlerts();
  useWatchMonitoringAlerts();
};

export default useRegister;
